import { applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import { LoadingState, LoadingStates } from 'globals/types';
import { FsSingleBarGraphDataProps } from 'ui-elements/charts/FsSingleBarGraph/FsSingleBarGraph';
import { BarGraph, BarGraphProps } from './bar-graph';
import { InfoBox, InfoBoxProps } from './info-box';

export interface BarGraphBoxProps {
  graphs: BarGraphProps[];
  infoBoxes: InfoBoxProps[];
  status: LoadingState;
}

export const BarGraphBox = types
  .model({
    graphs: types.optional(types.array(BarGraph), []),
    infoBoxes: types.optional(types.array(InfoBox), []),
    status: types.optional(
      types.enumeration(LoadingStates),
      LoadingState.INITIAL
    ),
  })
  .actions((self) => ({
    set(props: BarGraphBoxProps): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        ...props,
      };
      applySnapshot(self, newSnapshot);
    },
    updateStatus(status: LoadingState): void {
      const currentSnapshot = getSnapshot(self);
      const newSnapshot = {
        ...currentSnapshot,
        status,
      };
      applySnapshot(self, newSnapshot);
    },
  }))
  .views((self) => ({
    graphsValues(): FsSingleBarGraphDataProps[] {
      return self.graphs.map((g) => g.singleBarGraphValues());
    },
  }));
